/**
 * Converts a message search result to include the other user's information.
 * @param client
 * @param result
 * @param userId
 * @returns {Promise<*>}
 */
export const otherUserToMessageSearch = async (client, result, userId) => {
  const channelId = result.message.cid.split(':')[1];
  const channel = client.channel('messaging', channelId);
  await channel.watch();
  const members = Object.values(channel.state.members);
  result.message.owner = result.message.user;
  result.message.user =  members.find(m => m.user_id !== userId)?.user;

  return result;
};